/* TWS cart (page + drawer): line changes, care-kit add-on, save for later and the sticky checkout bar.
   Every change goes through the Cart AJAX API with `sections`, then the server-rendered regions
   ([data-twc-region][data-twc-part]) are swapped, so prices always come from Liquid's money filter.
   The express-checkout block sits outside those regions and is never replaced. */
(function () {
  if (window.twcCart) return;

  var SAVED_KEY = 'twc-saved-for-later';
  var routesCfg = window.routes || {};
  var ADD_URL = (routesCfg.cart_add_url || '/cart/add') + '.js';
  var CHANGE_URL = (routesCfg.cart_change_url || '/cart/change') + '.js';
  var busy = false;

  /* ---------- saved for later (guest fallback, this browser only) ---------- */
  function readSaved() {
    try {
      var list = JSON.parse(window.localStorage.getItem(SAVED_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }
  function writeSaved(list) {
    try {
      window.localStorage.setItem(SAVED_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  function refreshSaved() {
    document.querySelectorAll('twc-saved').forEach(function (el) { el.render(); });
  }

  /* ---------- section rendering ---------- */
  function all(selector) { return Array.prototype.slice.call(document.querySelectorAll(selector)); }

  function sectionIds() {
    var ids = all('[data-twc-region]').map(function (el) { return el.getAttribute('data-twc-region'); });
    ids.push('cart-icon-bubble');
    return ids.filter(function (id, i) { return ids.indexOf(id) === i; });
  }

  function render(sections) {
    var parsed = {};
    all('[data-twc-region]').forEach(function (el) {
      var id = el.getAttribute('data-twc-region');
      if (!sections || !sections[id]) return;
      if (!parsed[id]) parsed[id] = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = parsed[id].querySelector(
        '[data-twc-region="' + id + '"][data-twc-part="' + el.getAttribute('data-twc-part') + '"]'
      );
      if (!fresh) return;
      Array.prototype.slice.call(fresh.attributes).forEach(function (a) {
        if (a.name.indexOf('data-twc-') === 0) el.setAttribute(a.name, a.value);
      });
      el.innerHTML = fresh.innerHTML;
    });

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections && sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    syncEmpty();
  }

  function itemCount() {
    var el = document.querySelector('[data-twc-count]');
    return el ? parseInt(el.getAttribute('data-twc-count'), 10) || 0 : 0;
  }

  function syncEmpty() {
    var empty = itemCount() === 0;
    all('[data-twc-root]').forEach(function (el) { el.classList.toggle('is-empty', empty); });
    all('.twc-cart__frame').forEach(function (el) { el.classList.toggle('drawer__inner-empty', empty); });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
  }

  function announce() {
    var src = document.querySelector('[data-twc-announce]');
    var text = src ? src.getAttribute('data-twc-announce') : '';
    all('[data-twc-status]').forEach(function (el) { el.textContent = text; });
  }

  function showError(message) {
    var src = document.querySelector('[data-twc-error]');
    var fallback = src ? src.getAttribute('data-twc-error') : '';
    all('[data-twc-errors]').forEach(function (el) { el.textContent = message === '' ? '' : message || fallback; });
  }

  function post(url, body) {
    body.sections = sectionIds();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw data;
        return data;
      });
    });
  }

  function run(url, body) {
    if (busy) return Promise.reject({ busy: true });
    busy = true;
    showError('');
    all('[data-twc-root]').forEach(function (el) { el.setAttribute('aria-busy', 'true'); });
    return post(url, body)
      .then(function (data) {
        render(data.sections);
        announce();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'twc-cart', cartData: data });
        }
        return data;
      })
      .catch(function (err) {
        showError(err && (err.description || err.message));
        throw err;
      })
      .finally(function () {
        busy = false;
        all('[data-twc-root]').forEach(function (el) { el.removeAttribute('aria-busy'); });
      });
  }

  function change(key, quantity, trigger) {
    var line = trigger && trigger.closest('[data-twc-line]');
    if (line && quantity === 0) line.classList.add('is-removing');
    return run(CHANGE_URL, { id: key, quantity: quantity }).catch(function (err) {
      if (line) line.classList.remove('is-removing');
      throw err;
    });
  }

  function add(variantId) {
    return run(ADD_URL, { items: [{ id: parseInt(variantId, 10), quantity: 1 }] });
  }

  /* ---------- actions ---------- */
  function saveForLater(btn) {
    var entry = {
      variant: btn.getAttribute('data-variant'),
      url: btn.getAttribute('data-url'),
      title: btn.getAttribute('data-title'),
      vendor: btn.getAttribute('data-vendor'),
      price: btn.getAttribute('data-price'),
      image: btn.getAttribute('data-image') || '',
    };
    var before = readSaved();
    // Written first so the re-rendered list already includes it; rolled back if the removal fails.
    writeSaved([entry].concat(before.filter(function (s) { return String(s.variant) !== entry.variant; })));
    change(btn.getAttribute('data-key'), 0, btn).catch(function () {
      writeSaved(before);
      refreshSaved();
    });
  }

  function unsave(variant) {
    writeSaved(readSaved().filter(function (s) { return String(s.variant) !== String(variant); }));
    refreshSaved();
  }

  function moveToCart(btn) {
    var row = btn.closest('[data-variant]');
    var variant = row && row.getAttribute('data-variant');
    if (!variant) return;
    btn.disabled = true;
    add(variant)
      .then(function () { unsave(variant); })
      .catch(function () {
        btn.disabled = false;
        var err = row.querySelector('[data-f="error"]');
        if (err) err.hidden = false;
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest(
      '[data-twc-remove],[data-twc-qty],[data-twc-save],[data-twc-addon-add],[data-twc-addon-remove],[data-twc-move],[data-twc-unsave]'
    );
    if (!t) return;
    e.preventDefault();
    if (t.disabled || busy) return;
    var ignore = function () {};
    if (t.hasAttribute('data-twc-remove') || t.hasAttribute('data-twc-addon-remove')) {
      change(t.getAttribute('data-key'), 0, t).catch(ignore);
    } else if (t.hasAttribute('data-twc-qty')) {
      change(t.getAttribute('data-key'), Math.max(parseInt(t.getAttribute('data-twc-qty'), 10) || 0, 0), t).catch(ignore);
    } else if (t.hasAttribute('data-twc-save')) {
      saveForLater(t);
    } else if (t.hasAttribute('data-twc-addon-add')) {
      t.disabled = true;
      add(t.getAttribute('data-variant')).catch(function () { t.disabled = false; });
    } else if (t.hasAttribute('data-twc-move')) {
      moveToCart(t);
    } else if (t.hasAttribute('data-twc-unsave')) {
      var row = t.closest('[data-variant]');
      if (row) unsave(row.getAttribute('data-variant'));
    }
  });

  /* ---------- express buttons: hide the "or" divider when no wallet renders on this device ---------- */
  function checkExpress() {
    all('[data-twc-express]').forEach(function (box) {
      var wrap = box.closest('[data-twc-express-wrap]');
      if (wrap) wrap.classList.toggle('has-buttons', box.getBoundingClientRect().height > 8);
    });
  }
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(checkExpress);
    var watchExpress = function () { all('[data-twc-express]').forEach(function (b) { ro.observe(b); }); };
    document.addEventListener('DOMContentLoaded', watchExpress);
    if (document.readyState !== 'loading') watchExpress();
    // product-form.js replaces the whole drawer after publishing cartUpdate; watch the new box once it lands.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(watchExpress, 0); });
    }
  }

  /* ---------- custom elements ---------- */
  function safeUrl(u) {
    return typeof u === 'string' && /^(\/(?!\/)|https:\/\/)/.test(u) ? u : '';
  }

  class TwcSaved extends HTMLElement {
    connectedCallback() {
      this.render();
    }
    render() {
      var list = this.querySelector('[data-twc-saved-list]');
      var tpl = this.querySelector('template');
      if (!list || !tpl) return;
      var inCart = (this.getAttribute('data-in-cart') || '').split(',');
      var saved = readSaved().filter(function (s) { return s && s.variant && inCart.indexOf(String(s.variant)) === -1; });
      list.textContent = '';
      saved.forEach(function (s) {
        var li = tpl.content.firstElementChild.cloneNode(true);
        li.setAttribute('data-variant', String(s.variant));
        var url = safeUrl(s.url);
        var img = safeUrl(s.image && s.image.indexOf('//') === 0 ? 'https:' + s.image : s.image);
        li.querySelector('[data-f="link"]').href = url || '#';
        var title = li.querySelector('[data-f="title"]');
        title.textContent = s.title || '';
        title.href = url || '#';
        li.querySelector('[data-f="vendor"]').textContent = s.vendor || '';
        li.querySelector('[data-f="price"]').textContent = s.price || '';
        var im = li.querySelector('[data-f="img"]');
        if (img) im.src = img; else im.remove();
        list.appendChild(li);
      });
      this.hidden = saved.length === 0;
    }
  }
  if (!customElements.get('twc-saved')) customElements.define('twc-saved', TwcSaved);

  class TwcSticky extends HTMLElement {
    connectedCallback() {
      var target = document.querySelector(this.getAttribute('data-target'));
      if (!target || !('IntersectionObserver' in window)) return;
      this.hidden = false;
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        self.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(target);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }
  if (!customElements.get('twc-sticky')) customElements.define('twc-sticky', TwcSticky);

  window.twcCart = { render: render, refreshSaved: refreshSaved };
})();
